import { service } from '../../../../helpers/http' 

export const ActionGetGrids = ({ dispatch }, payload) => { 
    return service({
        module: 'domainGrid',
        action: 'getGrids',
        payload: payload
    })
}

export const ActionPostGrids = ({ dispatch }, payload) => {

    return service({
        module: 'domainGrid',
        action: 'postGrids',
        payload: payload
    })
    
}

export const ActionPutGrids = ({ dispatch }, payload) => {

    return service({
        module: 'domainGrid',
        action: 'putGrids',
        payload: payload
    })
    
}

export const ActionDeleteGrids = ({ dispatch }, payload) => {

    return service({
        module: 'domainGrid',
        action: 'deleteGrids',
        payload: payload
    })
    
}
